module.exports = __webpack_public_path__ + "static/media/CNews7.4faa41d8.png";